import AES from 'crypto-js/aes'
import CryptoJSCore from 'crypto-js/core'
import NoPadding from 'crypto-js/pad-nopadding'

// 原本の src/utils/standAES.ts は #7595 で旧スタック一式（bluetooth/packet/standAES/crc）と共に
// 削除された。本ファイルが AES crypto の正本。

// https://gist.github.com/lettergram/ba6733a854f835bca22b
const u8arrayEncoder = {
  stringify: function (wordArray: CryptoJSCore.lib.WordArray) {
    const words = wordArray.words
    const sigBytes = wordArray.sigBytes
    const u8 = new Uint8Array(sigBytes)
    for (let i = 0; i < sigBytes; i++) {
      const byte = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff
      u8[i] = byte
    }
    return u8
  },
  parse: function (u8arr: Uint8Array) {
    const len = u8arr.length
    const words: number[] = []
    for (let i = 0; i < len; i++) {
      words[i >>> 2] |= (u8arr[i] & 0xff) << (24 - (i % 4) * 8)
    }
    return CryptoJSCore.lib.WordArray.create(words, len)
  },
}

const bleModuleKey = [0x75, 0x6d, 0x62, 0x72, 0x65, 0x6c, 0x6c, 0x61]

// NOTE: 実際の unix は +901214048 補正で約26.8億(>2^31)。JS の `>>` は int32 化するため
// `unix >> 24` 等は負値になり得るが、結果を Uint8Array スロットへ格納する時点で mod 256 マスクが
// 効き Dart の `(unix >> 24) & 0xff` と一致する（>2^31 でも安全）。素の number として読むと壊れるので
// 必ず Uint8Array 経由のままにすること（JS↔Dart のシフト幅トラップ）。
export function generateFourRandomValues(unix: number): Uint8Array {
  const randoms = new Uint8Array(4)
  randoms[0] = unix >> 16
  randoms[1] = unix
  randoms[2] = unix >> 24
  randoms[3] = unix >> 8
  return randoms
}

export function generateEncryptKey(randoms: Uint8Array): Uint8Array {
  return new Uint8Array([...randoms, ...bleModuleKey, ...randoms])
}

export function encrypt(
  plainBytes: Uint8Array,
  key: Uint8Array,
  iv: Uint8Array
): Uint8Array {
  const plainBytesWords = u8arrayEncoder.parse(plainBytes)
  const keyWords = u8arrayEncoder.parse(key)
  const ivWords = u8arrayEncoder.parse(iv)
  const encrypted = AES.encrypt(plainBytesWords, keyWords, {
    iv: ivWords,
    mode: CryptoJSCore.mode.CBC,
    // ONLY decrypt with no padding（encrypt は既定の PKCS7。platform 同一の意図的非対称）
  })
  const encryptedString = encrypted.toString()
  const rawString = window.atob(encryptedString)
  return Uint8Array.from(rawString.split('').map((c) => c.charCodeAt(0)))
}

export function decrypt(
  encryptedBytes: Uint8Array,
  key: Uint8Array,
  iv: Uint8Array
): Uint8Array {
  const rawString = String.fromCharCode.apply(
    null,
    encryptedBytes as unknown as number[]
  )
  const encryptedString = window.btoa(rawString)
  const keyWords = u8arrayEncoder.parse(key)
  const ivWords = u8arrayEncoder.parse(iv)
  const decrypted = AES.decrypt(encryptedString, keyWords, {
    iv: ivWords,
    mode: CryptoJSCore.mode.CBC,
    padding: NoPadding,
  })
  return u8arrayEncoder.stringify(decrypted)
}
